<template>
  <div class="AwardsContent ">
    <video class="video2" autoplay loop muted playsinline>
      <source  :src="video_src3" type="video/mp4" key="2">
    </video>
    <div class="bg_filter"></div>
    <div class="lightbox" v-if="isLightbox" >
       <transition appear name="pageTitle">
        <img :src="imgLightbox" alt="img" @click="isLightbox = !isLightbox">
       </transition>
       <transition appear name="pageTitle">
        <button @click="isLightbox = !isLightbox">Close</button>
      </transition>
    </div>
    
      <div class="content-header">
        <transition appear name="pageTitle">
          <h1>AWARDS</h1>
        </transition>
          <!-- <div class="select-menu">
            <ul>
              <li>
                <input type="radio" name="selectMenu" value="menu1" checked id="radio01" />
                <label for="radio01" class="select-menu-label">menu1</label>
              </li>
              <li>
                <input type="radio" name="selectMenu" value="menu1" checked id="radio02" />
                <label for="radio02" class="select-menu-label">menu2</label>
              </li>
              <li>
                <input type="radio" name="selectMenu" value="menu1" checked id="radio03" />
                <label for="radio03" class="select-menu-label">menu3</label>
              </li>
            </ul>
          </div> -->
      </div>
     
      <div class="grid-wrapper">
       
        <!-- <div class="item item1 item-card" v-for="(img, index ) in items" v-bind:key="index" >
            <img class="item-img" v-lazy="img.path" v-if="img.isUse">
        </div> -->
        <!-- <div class="grid-items" v-for="(img, index ) in items" v-bind:key="index">
          <div v-if="img.isUse" class="item" :style="{'background-image': 'url(' + img.path + ')' , 'background-size':'cover', 'background-position':'center'}">
            
          </div>
          <div v-if="!img.isUse" class="item item-card" >
            <div class="bg_filter v2_filter"></div>
           <p>{{img.title}}</p>
           <h3>{{img.discription}}</h3>
           <p><span>{{img.pref}}</span><span>{{img.place}}</span></p>
          </div>
        </div> -->
      
          
          <div class="item item1  item-card item-awards-title-block">
            <transition appear name="pageTitle">
              <h1>2018 BEST WORKS  </h1>
            </transition>
            <transition appear name="pageTitle">
              <p>The awards for photos,design,creativity on my blog.
                I always want to evolve this blog's TOURdeHDR+.
              </p>
            </transition>
            
            <transition appear name="pageTitle">
              <div class="awards-list">
                  <!-- <p>TITLE BEST</p> -->
                  <p>STAGE BEST</p>
                  <p>CREATE BEST</p>
                  <p>VEHICLE BEST</p>
                  <p>TWILITE BSET</p>
                  <p>NIGHT BEST </p>
                  <p>HDR BEST</p>
              </div>
            </transition>
            
          </div>
          <div class="item item2  item-flex-center">
            <img :src="img1" alt="img" class="stage-imges-top">
          </div>
          <div class="item item3 item-card item-flex-center">
            <!-- <img :src="img2" :alt="img.title" class="stage-imges"> -->
            <div class="awards-title">
                <h1>STAGE BEST </h1>
                <p>I picked up a good photos of stage best.</p>
            </div>
          </div>
          <div class="item item4" v-on:click="lightbox(imgstage1)" 
           :style="{'background-image': 'url(' + imgstage1 + ')' , 'background-size':'cover', 'background-position':'bottom right'}"><div class="stage-no">STAGE1</div></div>
          <div class="item item5" v-on:click="lightbox(imgstage2)"
           :style="{'background-image': 'url(' + imgstage2 + ')' , 'background-size':'cover', 'background-position':'center'}"><div class="stage-no">STAGE2</div></div>
          <div class="item item6" v-on:click="lightbox(imgstage3)"
           :style="{'background-image': 'url(' + imgstage3 + ')' , 'background-size':'cover', 'background-position':'top left'}"><div class="stage-no">STAGE3</div></div>
          <div class="item item7" v-on:click="lightbox(imgstage4)"
           :style="{'background-image': 'url(' + imgstage4 + ')' , 'background-size':'cover', 'background-position':'center'}"><div class="stage-no">STAGE4</div></div>
          <div class="item item8" v-on:click="lightbox(imgstage5)"
           :style="{'background-image': 'url(' + imgstage5 + ')' , 'background-size':'cover', 'background-position':'center'}"><div class="stage-no">STAGE5</div></div>
          <div class="item item9" v-on:click="lightbox(imgstage6)"
           :style="{'background-image': 'url(' + imgstage6 + ')' , 'background-size':'cover', 'background-position':'center'}"><div class="stage-no">STAGE6</div></div>
          <div class="item item10" v-on:click="lightbox(imgstage7)"
           :style="{'background-image': 'url(' + imgstage7 + ')' , 'background-size':'cover', 'background-position':'center'}"><div class="stage-no">STAGE7</div></div>
          <div class="item item11" v-on:click="lightbox(imgstage8)"
           :style="{'background-image': 'url(' + imgstage8 + ')' , 'background-size':'cover', 'background-position':'center'}"><div class="stage-no">STAGE8</div></div>
          <div class="item item12" v-on:click="lightbox(imgstage9)"
           :style="{'background-image': 'url(' + imgstage9 + ')' , 'background-size':'cover', 'background-position':'center'}"><div class="stage-no">STAGE9 </div></div>
          <div class="item item13" v-on:click="lightbox(imgstage10)"
           :style="{'background-image': 'url(' + imgstage10 + ')' , 'background-size':'cover', 'background-position':'center'}"><div class="stage-no">STAGE10</div></div>
          <div class="item item14" v-on:click="lightbox(imgstage11)"
           :style="{'background-image': 'url(' + imgstage11+ ')' , 'background-size':'cover', 'background-position':'center'}"><div class="stage-no">STAGE11</div></div>
          <!-- create -->
          <div class="item item15 item-card item-flex-center">
            <!-- <img :src="img2" :alt="img.title" class="stage-imges"> -->
            <div class="awards-title">
                <h1>CREATE BEST </h1>
                <p>I picked up a good Works synthesizing 3d model material into photos</p>
            </div>
          </div>
          <div class="item item16" v-on:click="lightbox(imgCreate1)"
           :style="{'background-image': 'url(' + imgCreate1+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <div class="item item17" v-on:click="lightbox(imgCreate2)"
           :style="{'background-image': 'url(' + imgCreate2+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <div class="item item18" v-on:click="lightbox(imgCreate3)"
           :style="{'background-image': 'url(' + imgCreate3+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <!-- vcl -->
          <div class="item item19 item-card item-flex-center">
            <!-- <img :src="img2" :alt="img.title" class="stage-imges"> -->            <div class="awards-title">
                <h1>VEHICLE BEST </h1>
                <p>I picked up a good photos of vehicle</p>
            </div>
          </div>
          <div class="item item20" v-on:click="lightbox(imgVcl1)"
           :style="{'background-image': 'url(' + imgVcl1+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <div class="item item21" v-on:click="lightbox(imgVcl2)"
           :style="{'background-image': 'url(' + imgVcl2+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <div class="item item22" v-on:click="lightbox(imgVcl3)"
           :style="{'background-image': 'url(' + imgVcl3+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <!-- twilite -->
          <div class="item item23 item-card item-flex-center">
            <!-- <img :src="img2" :alt="img.title" class="stage-imges"> -->
            <div class="awards-title">
                <h1>TWILITW BEST </h1>
                <p>I picked up a good photos of twilite</p>
            </div>
          </div>
          <div class="item item24" v-on:click="lightbox(imgTwilite1)"
           :style="{'background-image': 'url(' + imgTwilite1+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <div class="item item25" v-on:click="lightbox(imgTwilite2)"
           :style="{'background-image': 'url(' + imgTwilite2+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <div class="item item26" v-on:click="lightbox(imgTwilite3)"
           :style="{'background-image': 'url(' + imgTwilite3+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <!-- vcl -->
          <div class="item item27 item-card item-flex-center">
            <!-- <img :src="img2" :alt="img.title" class="stage-imges"> -->
            <div class="awards-title">
                <h1>NIGHT BEST </h1>
                <p>I picked up a good photos of night</p>
            </div>
          </div>
          <div class="item item28" v-on:click="lightbox(imgNight1)"
           :style="{'background-image': 'url(' + imgNight1+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <div class="item item29" v-on:click="lightbox(imgNight2)"
           :style="{'background-image': 'url(' + imgNight2+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <div class="item item30" v-on:click="lightbox(imgNight3)"
           :style="{'background-image': 'url(' + imgNight3+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <!-- vcl -->
          <div class="item item31 item-card item-flex-center">
            <!-- <img :src="img2" :alt="img.title" class="stage-imges"> -->
            <div class="awards-title">
                <h1>HDR BEST </h1>
                <p>I picked up a good photos of HDR</p>
            </div>
          </div>
          <div class="item item32" v-on:click="lightbox(imgHdr1)"
           :style="{'background-image': 'url(' + imgHdr1+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <div class="item item33" v-on:click="lightbox(imgHdr2)"
           :style="{'background-image': 'url(' + imgHdr2+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
          <div class="item item34" v-on:click="lightbox(imgHdr3)"
           :style="{'background-image': 'url(' + imgHdr3+ ')' , 'background-size':'cover', 'background-position':'center'}"></div>
    </div>

    <div class="content-footer">
        <div class="footer-menu">
          <router-link to="/">
          <h3>HOME</h3>
          <p>2018 TOURdeHDR+ COLLECTION</p>
          <p>STAGE 1 - 11</p>
          </router-link>
        </div>
        <div class="footer-menu">
          <router-link to="/project">
          <h3>STAGE</h3>
          <p>It is the main picture of the stage</p>
           </router-link>
        </div>
        <div class="footer-menu">
           <router-link to="/awards">
          <h3>AWARDS</h3>
          <p>I picked up a good picture of the year</p>
          </router-link>
        </div>
      </div>
      <div class="sns-footer">
        <a href="https://twitter.com/TOURdeHDR" target="_blank">
          <div class="sns-item"><i class="fab fa-3x fa-twitter-square"></i></div>
        </a>
        <a href="https://www.instagram.com/yoshiak_hiramatsu_hdr/?hl=ja" target="_blank">
          <div class="sns-item"><i class="fab fa-3x fa-instagram"></i></div>
        </a>
        <a href="http://tourdehdr.sakuratan.com/site2/" target="_blank">
          <div class="sns-item">
             <svg version="1.1" id="レイヤー_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                y="0px" viewBox="0 0 1280 1024" style="enable-background:new 0 0 1280 1024;" xml:space="preserve">

                <g>
                  <path class="st0" d="M447,779c-16,0-29-13-29-29V312c0-16,13-29,29-29h438c16,0,29,13,29,29v438c0,16-13,29-29,29H447z"/>
                  <path d="M885,285c14.9,0,27,12.1,27,27v438c0,14.9-12.1,27-27,27H447c-14.9,0-27-12.1-27-27V312c0-14.9,12.1-27,27-27H885 M885,281
                    H447c-17.1,0-31,13.9-31,31v438c0,17.1,13.9,31,31,31h438c17.1,0,31-13.9,31-31V312C916,294.9,902.1,281,885,281L885,281z"/>
                </g>
                <g>
                  <path d="M570.1,312.4v237.2h-61.7V450H490v99.6h-61.7V312.4H490v84.8h18.5v-84.8H570.1z"/>
                </g>
                <g>
                  <path class="st1" d="M595.4,378.5h46.1c29.8,0,49.9,1.4,60.4,4.1c10.5,2.7,18.5,7.2,24,13.5c5.5,6.3,8.9,13.2,10.3,20.9
                    c1.4,7.7,2.1,22.7,2.1,45.2v83.1c0,21.3-1,35.5-3,42.7c-2,7.2-5.5,12.8-10.5,16.8c-5,4.1-11.1,6.9-18.5,8.5s-18.4,2.4-33.1,2.4
                    h-77.8V378.5z M657.1,419.1v156c8.9,0,14.4-1.8,16.4-5.3c2.1-3.6,3.1-13.3,3.1-29.1v-92.1c0-10.7-0.3-17.6-1-20.7
                    c-0.7-3-2.2-5.2-4.7-6.7C668.4,419.8,663.8,419.1,657.1,419.1z"/>
                </g>
                <g>
                  <path class="st2" d="M766.7,444.7h43.7c29.1,0,48.8,1.1,59.1,3.4c10.3,2.2,18.7,8,25.2,17.2c6.5,9.2,9.7,24,9.7,44.2
                    c0,18.5-2.3,30.9-6.9,37.2c-4.6,6.3-13.6,10.2-27.1,11.4c12.2,3,20.4,7.1,24.6,12.2c4.2,5.1,6.8,9.7,7.8,14s1.5,15.9,1.5,35.1v62.5
                    h-57.3V603c0-12.7-1-20.6-3-23.6c-2-3-7.3-4.5-15.7-4.5v106.9h-61.7V444.7z M828.4,485.2V538c6.9,0,11.8-1,14.6-2.9
                    s4.2-8.1,4.2-18.5v-13c0-7.5-1.3-12.5-4-14.8C840.4,486.4,835.5,485.2,828.4,485.2z"/>
                </g>
                <g>
                  <rect x="342" y="1159" width="583" height="129"/>
                </g>
                <g>
                  <path d="M416,690v60c0,17.1,13.9,31,31,31h438c17.1,0,31-13.9,31-31v-60H416z"/>
                </g>
              </svg>
          </div>
        </a>
      </div>
      <div class="sns-footer">
          <div class="sns-item"><i class="fas fa-copyright">TOURdeHDR</i></div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'awardsContent',
  props: {
    msg: String
  },
  data() {
    return {
      isLightbox: false,
      imgLightbox: null,
     
      // video_src1: require("../assets/img/Indian Tea.mp4"),
      // video_src2: require("../assets/img/Painting960.mp4"), 
      video_src3: require("../assets/img/Night-Traffic.mp4"),
      isTitle: true,

      img1: require("../assets/img/hdr/awards2018mozaiku_white.jpg"),
      // img2: require("../assets/img/hdr/awards2017red2.jpg"),
      // imgTitle1: require("../assets/img/hdr/img7718_titleMini.jpg"),
      // imgTitle2: require("../assets/img/hdr/BrightChristmas.jpg"),
      // imgTitle3: require("../assets/img/hdr/hinase_title3.jpg"),

      imgstage1: require("../assets/img/hdr/img6656.jpg"),
      imgstage2: require("../assets/img/hdr/img5951.jpg"),
      imgstage3: require("../assets/img/hdr/imag5549_comp_starwars2.jpg"),
      imgstage4: require("../assets/img/hdr/img0639a.jpg"),
      imgstage5: require("../assets/img/hdr/img7682b.jpg"),
      imgstage6: require("../assets/img/hdr/img4533.jpg"),
      imgstage7: require("../assets/img/hdr/9730blue.jpg"),
      imgstage8: require("../assets/img/hdr/img3654.jpg"),
      imgstage9: require("../assets/img/hdr/img9160.jpg"),
      imgstage10: require("../assets/img/hdr/img7383.jpg"),
      imgstage11: require("../assets/img/hdr/BrightChristmas2.jpg"),
      
      imgNight1: require("../assets/img/hdr/img7718c.jpg"),
      imgNight3: require("../assets/img/hdr/BrightChristmas2.jpg"),
      imgNight2: require("../assets/img/hdr/img7700.jpg"),

      imgTwilite1: require("../assets/img/hdr/img9856a.jpg"),
      imgTwilite2: require("../assets/img/hdr/img7433.jpg"),
      imgTwilite3: require("../assets/img/hdr/img7610.jpg"),

      imgCreate1: require("../assets/img/hdr/img5582.jpg"),
      imgCreate2: require("../assets/img/hdr/img5525_comp.jpg"),
      imgCreate3: require("../assets/img/hdr/img5777_comp.jpg"),

      imgVcl1: require("../assets/img/hdr/img6233a.jpg"),
      imgVcl2: require("../assets/img/hdr/img6606.jpg"),
      imgVcl3: require("../assets/img/hdr/img5849.jpg"),

      imgHdr2: require("../assets/img/hdr/img7383.jpg"),
      imgHdr1: require("../assets/img/hdr/img4122.jpg"),
      imgHdr3: require("../assets/img/hdr/img3006.jpg"),
    }
  },
  // created() {
  // },
  // mounted: function(){

      // window.addEventListener("DOMContentLoaded", this.handleLoad);
        // this.loading = true;
        // this.getUnits()
  // },
   methods: {
    lightbox: function(img){
        this.isLightbox = true;
        this.imgLightbox = img;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//  @import "../assets/scss/page/AwardsComponent.scss";
.AwardsContent{
  width: 100%;
  height: 100%;
  text-align: center;
  padding: auto 0;
}
.load-containt{
  width: 100vw;
  height: 100vh;
  display: flex;
 
  background-color: #9b2727;
  z-index: 1000;
}
.title{
  width: 20rem;
  height: 3rem;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  margin: auto;
}

//header
.content-header{
  position: relative;
  width: 100%;
  height: 20rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-header .select-menu{
  position: absolute;
  top: 10rem;
  left: 0;
}
.content-header .select-menu ul{
  margin: 1rem;
}
.content-header .select-menu .select-menu-label{
  font-size: .6rem;
  margin: 0 .5rem;
  vertical-align: bottom;
}
.content-header h1{
    letter-spacing:1.5rem; 
}
.content-footer{
  position: relative;
  width: 100vw;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  @media (min-width:992px) {
    justify-content: space-around;
    flex-direction: row;
  }
}
.footer-menu{
  width: 100%;
  padding: 1rem;
  text-align: center;
  h3{
    font-size: 3rem;
  }
  p{
    font-size: 1rem; 
  }
  
  @media (min-width:992px) {
    text-align: left;
    width: 25%;
   h3{
      font-size: 3rem;
    }
    p{
     font-size: 1.5rem; 
    }
  }
}
.sns-footer{
  position: relative;
  width: 100%;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sns-item{
  text-align: center;
  margin: 0 ;
     font-size: .5rem; 
     @media (min-width:992px) {
      font-size: 1rem;  
    }
    i{
      margin: 0 2rem;
    }
}

//gulid
.grid-wrapper{
  position: relative;
  margin: 0;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  grid-template-columns: repeat(2, 1fr)  ;
  margin: 0px;
  @media (min-width:768px) {
   display: grid;
   grid-template-columns: repeat(4, 1fr) ;
  }
  @media (min-width:1200px) {
   display: grid;
   grid-template-columns: repeat(6, 1fr) ;
  }
}
.item, {
  position: relative;
  overflow:hidden;
  text-align: left;
  grid-column: span 2;
  min-height:  18rem;
  background-position: center;
  @media (min-width:400px) {
   min-height: 18rem ;
  }
  @media (min-width:500px) {
   min-height: 22rem ;
  }
   @media (min-width:600px) {
   min-height: 28rem ;
  }
   @media (min-width:768px) {
   min-height: 32rem ;
  }
   @media (min-width:1040px) {
   min-height: 45rem ;
  }
  //3
   @media (min-width:1200px) {
   min-height: 18rem ;
  }
   @media (min-width:1440px) {
   min-height: 22rem ;
  }
   @media (min-width:1800px) {
   min-height: 27rem ;
  }
   @media (min-width:2200px) {
   min-height: 31rem ;
  }
   @media (min-width:2500px) {
   min-height: 37rem ;
  }
   @media (min-width:3000px) {
   min-height: 43rem ;
  }
   @media (min-width:3500px) {
   min-height: 50rem ;
  }
   @media (min-width:4000px) {
   min-height: 56rem ;
  }
}

.item-img{
  width: 100%;
  height: auto;
}
.item-card{
  padding: .5rem 1rem;
  border: 1px solid rgba(250,250,250,.2);
  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.8);
}
.item-left{
  text-align: left;
}
.item-center{
  text-align: center;
}
.item-right{
  text-align: right;
}
.item-flex-center{
  display:flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.item-flex-start{
  display:flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}

.stage-imges-top{
  width: 100%;
  height: auto;
  display: inline-block;
  margin: 0 auto 0 0;
  padding: 2rem;
  @media (min-width:2000px) {
    padding: 0;
  }
}
.stage-imges{
  width: 100%;
  height: auto;
  display: inline-block;
  margin: 1rem auto ;
}
.item-awards-title-block{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding:  3rem 2rem ;
  h3{
    font-size: 10rem;
  }
  p{
    font-size: 1rem;
    margin: 0 1rem; 
  }
   @media (min-width:2000px) {
    justify-content: flex-start;
    align-items: flex-start;
    padding: 3rem;
  }
  
}
.awards-list{
    margin-top: 3rem;
    width: 100%;
    text-align: center;
    @media (min-width:2000px) {
      text-align: left;
    }
    h1{
        text-shadow:
        1px 1px 1px #fff,
        1px -1px 1px #fff,
        -1px 1px 1px #fff,
        -1px -1px 1px #fff,
        0 0 22px #fff;
    }
}
.awards-title{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    p{
      font-size: .8rem;
    }
    @media (min-width:768px) {
      p{
      font-size: 1rem;
      }
    }
}
.stage-no{
    position: absolute;
    top: .5rem;
    right: .5rem;
    padding: .2rem .3rem;
    background-color: rgba(250,250,250,.8);
    color: #212121;
    font-size: .8rem;
    line-height: 1.2rem;
    vertical-align: baseline;
}
.item1{
 @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: 1/span 1;
  }
   @media (min-width:1200px) {
    grid-column: 1/ span 2;
    grid-row: 1/ span 2;
  }

}
.item2{
    @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: 2/span 1;
  }
   @media (min-width:1200px) {
    grid-column: span 4;
    grid-row: span 1;
  }
}
// stage best
.item3, {
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: 3/span 1;
  }
   @media (min-width:1200px) {
    grid-column: span 6;
    grid-row:  3/span 1;
  }
}
//s1
.item4{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2 ;
    grid-row: 4/span 1;
  }
}
//s2
.item5{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 3/ span 4;
    grid-row: 4/span 2;
  }
}
//s3
.item6{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2;
    grid-row: 5/span 1;
  }
}
//s4
.item7{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 3;
    grid-row: 6/span 1;
  }
}
//s5
.item8{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 4/span 3;
    grid-row: 6/span 1;
  }
}

//s6
.item9{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2;
    grid-row: 7/span 2;
  }
}
//s7
.item10{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 3/span 4;
    grid-row: 7/span 1;
  }
}
//s8
.item11{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 3/span 2;
    grid-row: 8/span 1;
  }
}
//s9
.item12{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 5/span 2;
    grid-row: 8/span 1;
  }
}
//s10
.item13{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 3;
    grid-row: 9/span 1;
  }
}
//s11
.item14{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 4/span 3;
    grid-row: 9/span 1;
  }
}
// create
.item15{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 1;
  }
   @media (min-width:1200px) {
    grid-column: span 6;
    grid-row:  10/span 1;
  }
}
//ceate1
.item16{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2 ;
    grid-row: 11/span 1;
  }
}
//create2
.item17{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 3/ span 4;
    grid-row: 11/span 2;
  }
}
//create3
.item18{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2;
    grid-row: 12/span 1;
  }
}
// vcl
.item19{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 1;
  }
   @media (min-width:1200px) {
    grid-column: span 6;
    grid-row:  13/span 1;
  }
}
//vcl1
.item20{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2 ;
    grid-row: 14/span 1;
  }
}
//vcl2
.item21{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 3/ span 4;
    grid-row: 14/span 2;
  }
}
//vcl3
.item22{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2;
    grid-row: 15/span 1;
  }
}



// twilite
.item23{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 1;
  }
   @media (min-width:1200px) {
    grid-column: span 6;
    grid-row:  16/span 1;
  }
}
//twilite1
.item24{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2 ;
    grid-row: 17/span 1;
  }
}
//twilite2
.item25{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 3/ span 4;
    grid-row: 17/span 2;
  }
}
//twilite3
.item26{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2;
    grid-row: 18/span 1;
  }
}



// night
.item27{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 1;
  }
   @media (min-width:1200px) {
    grid-column: span 6;
    grid-row:  19/span 1;
  }
}
//night1
.item28{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2 ;
    grid-row: 20/span 1;
  }
}
//night2
.item29{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 3/ span 4;
    grid-row: 20/span 2;
  }
}
//night3
.item30{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2;
    grid-row: 21/span 1;
  }
}


// HDRl
.item31{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: span 4;
    grid-row: span 1;
  }
   @media (min-width:1200px) {
    grid-column: span 6;
    grid-row:  22/span 1;
  }
}
//HDR1
.item32{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2 ;
    grid-row: 23/span 1;
  }
}
//HDR2
.item33{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 3/ span 4;
    grid-row: 23/span 2;
  }
}
//HDR3
.item34{
  @media (min-width:500px) {
   width: 100%;
    grid-column: span 2;
    grid-row: span 1;
  }
   @media (min-width:768px) {
    grid-column: 1/span 4;
    grid-row: span 3;
  }
   @media (min-width:1200px) {
    grid-column: 1/span 2;
    grid-row: 24/span 1;
  }
}






video.video2, video.video3 {
  position: fixed;
  top: 0%;
  left: 0%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  display: block;
}

.bg_filter{
    background-color: rgba(0,0,0,.6);
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    
}
svg{
  width: 60px;
  height: 60px;
  margin: 0rem;
  @media (min-width:992px) {
    width: 110px;
    height: 110px;
    margin: 0rem;
  }

}
.st0{
  fill:#FFFFFF;
  &:hover{
    fill:rgb(93, 226, 60);
  }
  }
.st1{fill:#333333;}
.st2{fill:#666666;}


// .lightbox{
//     position: fixed;
//     width: 100vw;
//     height: 100vh;
//     background-color: rgba(0,0,0,.7);
//     z-index:1000;
//     top: 0;
//     right: 0;
//     bottom: 0;
//     left: 0;
//     overflow: hidden;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     flex-direction: column;
//     padding: 1rem;
//     @media screen and (orientation: landscape) {
    /* 横向きの場合のスタイル */
    //  flex-direction: row;
    // }
    // @media screen and (orientation: portrait) {
     /* 縦向きの場合のスタイル */
//      flex-direction: column;
//     }
// }
// .lightbox img{
    /* 横向きの場合のスタイル */

    // display: inline-block;
    // @media (max-width: 767px) and (orientation: landscape) {
    //  width: auto;
    //  height: 100%;
    //  border: 2px solid white;
    // }
    // @media (min-width: 768px) and (orientation: landscape) {
    //  width: auto;
    //  height: 80%;
    //  border: 5px solid white;
    // }
    // @media (min-width: 1024px) and (orientation: landscape) {
    //  width: auto;
    //  height: 75%;
    //  border: 10px solid white;
    // }
    // @media (min-width: 1400px) and (orientation: landscape) {
    //  width: auto;
    //  height: 60%;
    //  border: 10px solid white;
    // }
    // @media (min-width: 2000px) and (orientation: landscape) {
    //  width: auto;
    //  height: 50%;
    //  border: 10px solid white;
    // }
    /* 縦向きの場合のスタイル */
//     @media (max-width: 767px) and (orientation: portrait) {
//      width: 100%;
//      height: auto;
//      border: 2px solid white;
//     }
//     @media (min-width: 768px) and (orientation: portrait) {
//      width: 80%;
//      height: auto;
//      border: 5px solid white;
//     }
//     @media (min-width: 1024px) and (orientation: portrait) {
//      width: 75%;
//      height: auto;
//      border: 10px solid white;
//     }
//     @media (min-width: 1400px) and (orientation: portrait) {
//      width: 60%;
//      height: auto;
//      border: 10px solid white;
//     }
//     @media (min-width: 2000px) and (orientation: portrait) {
//      width: 50%;
//      height: auto;
//      border: 10px solid white;
//     }
    
// }
// .lightbox button{
//     margin: 1rem;
// }
</style>
